var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoBocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    width: 280,
    height: 280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo_bocal-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ce383a } \n\t\t.s1 { fill: #000000 } \n\t\t.s2 { fill: #51267c } \n\t\t.s3 { fill: #eda9a5 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m217.4 157.5c0 46-34.8 83.2-77.7 83.2c-42.9 0-77.7-37.2-77.7-83.2c0-46 47.1-16.7 89.1-10.6c24.9 3.7 66.3-35.3 66.3 10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m140.3 259.4c-53.1 0-96.4-43.2-96.4-96.4c0-16.6 4.3-33 12.5-47.4l9.6 5.4c-7.2 12.7-11 27.3-11 42c0 47.1 38.3 85.4 85.4 85.4c47.1 0 85.4-38.3 85.4-85.4c0-14.5-3.7-28.9-10.7-41.5l9.6-5.4c7.9 14.2 12.1 30.4 12.1 46.8c-0.1 53.3-43.4 96.5-96.5 96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m146.7 77.7c-14.2 0-25.7-11.5-25.7-25.7c0-14.2 11.5-25.7 25.7-25.7c14.2 0 25.7 11.5 25.7 25.7c0 14.2-11.5 25.7-25.7 25.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m103.9 83.7c-4.5 0-8.1-3.6-8.1-8.1c0-4.5 3.6-8.1 8.1-8.1c4.5 0 8.1 3.6 8.1 8.1c0 4.5-3.6 8.1-8.1 8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m114.6 122.8c-8.3 0-15-6.7-15-15c0-8.3 6.7-15 15-15c8.3 0 15 6.7 15 15c0 8.3-6.7 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m161.3 112.7c-5.6 0-10.2-4.6-10.2-10.2c0-5.6 4.6-10.2 10.2-10.2c5.6 0 10.2 4.6 10.2 10.2c0 5.6-4.6 10.2-10.2 10.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m138.3 195.5c-9 0-16.2-7.2-16.2-16.2c0-9 7.2-16.2 16.2-16.2c9 0 16.2 7.2 16.2 16.2c0 9-7.2 16.2-16.2 16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m161.5 217.6c-5.3 0-9.5-4.2-9.5-9.5c0-5.3 4.2-9.5 9.5-9.5c5.3 0 9.5 4.2 9.5 9.5c0 5.3-4.2 9.5-9.5 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m177.7 191.9c-5.3 0-9.5-4.2-9.5-9.5c0-5.3 4.2-9.5 9.5-9.5c5.3 0 9.5 4.2 9.5 9.5c0 5.3-4.2 9.5-9.5 9.5z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBocal);
export default __webpack_public_path__ + "static/media/Logo_bocal.1a1a670e4f121c1cc38d0706e348e350.svg";
export { ForwardRef as ReactComponent };